var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "_70-Trash",
    "data-name": "70-Trash",
    style: {
      stroke: "#000",
      fill: "#000"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.89,6.55l-1-2A1,1,0,0,0,28,4H21V2a2,2,0,0,0-2-2H13a2,2,0,0,0-2,2V4H4a1,1,0,0,0-.89.55l-1,2A1,1,0,0,0,3,8H5V30a2,2,0,0,0,.47,1.41A2,2,0,0,0,7,32H25a2,2,0,0,0,2-2V8h2a1,1,0,0,0,.89-1.45ZM13,2h6V4H13ZM25,30H7V8H25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17,26V10a2,2,0,0,0-2,2l.06,14H15v2A2,2,0,0,0,17,26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22,26V10a2,2,0,0,0-2,2l.06,14H20v2A2,2,0,0,0,22,26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26V10a2,2,0,0,0-2,2l.06,14H10v2A2,2,0,0,0,12,26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteTrash);
export default __webpack_public_path__ + "static/media/delete-trash.843a88e4edb2be71527f5146a2826a66.svg";
export { ForwardRef as ReactComponent };